import React, { type FC } from 'react'

import { objectKeys } from '../../../../utils'

import { type CybusPermission, Translation } from '../../../../domain'

import { useTranslator } from '../../Internationalization'
import { useAppUsecase } from '../../State'
import { Page } from '../Page'
import { useContextName } from './Hooks'

export const PermissionsPage: FC = () => {
    const translator = useTranslator()
    const translateName = useContextName()
    const viewPermissionUsecase = useAppUsecase('viewPermissionUsecase')

    return (
        <Page<CybusPermission>
            selected="permissions"
            columns={{
                resource: { label: translator.formatTranslation(Translation.RESOURCE, { count: 0 }) },
                context: {
                    label: Translation.CONTEXT,
                    customCellRender: translateName,
                },
                users: {
                    label: translator.formatTranslation(Translation.USER, { count: 2 }),
                    customCellRender: (users) => translator.formatTranslation(Translation.ACTIVE_USER, { count: objectKeys(users).length }),
                },
                roles: {
                    label: translator.formatTranslation(Translation.ROLE, { count: 2 }),
                    customCellRender: (roles) => translator.formatTranslation(Translation.ACTIVE_ROLE, { count: objectKeys(roles).length }),
                },
            }}
            notFound={Translation.NO_PERMISSIONS_FOUND}
            onRowClick={(permission) => viewPermissionUsecase.show(permission)}
        />
    )
}
